webpackJsonp([1],{

/***/ "DN8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JQt9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K1ID":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LE3U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LhO9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
  //TODO - Add transition classes
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b092746","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("QE36")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22c00d4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JQt9")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2d63fc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("jsA2")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-b2d63fc6"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d48a67d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("DN8u")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-6d48a67d"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-628dded4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("OXBz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var NavigationBar = ({
  props: ['logoURL', 'title', 'page', 'companyName', 'width'],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['zoomEnabled', 'contentsEnabled', 'searchEnabled', 'languagesEnabled', 'downloadEnabled', 'printEnabled', 'rightToLeft', 'companyLogo', 'downloadPath', 'showContents', 'showLanguages', 'showSearch', 'isZoomed']), {
    divider: function divider() {
      if (this.rightToLeft) return 'chevron-left';
      return 'chevron-right';
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleLanguages: 'TOGGLE_LANGUAGES',
    toggleZoom: 'TOGGLE_ZOOM',
    toggleSearch: 'TOGGLE_SEARCH'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53d73712","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(_vm.zoomEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()])])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("LhO9")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c0b846","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("LE3U")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ContentsPanel = ({
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    getBackgroundURL: function getBackgroundURL(index) {
      return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
    }

  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-553cbac8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('li',{key:index,staticClass:"contents-item",on:{"click":function($event){_vm.goToPage({pageIndex: index + 1, sectionIndex: 1})}}},[_c('div',{staticClass:"contents-item__text"},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(page[0].title))])]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(index)})})])}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("h0Q/")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17490c4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("qdF7")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3df2afbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)])])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("gmqq")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    MobileContainer: components_mobile_MobileContainer,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    VideoContainer: src_components_VideoContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'isZoomed'])),
  mounted: function mounted() {
    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch)) {
      this.loadScripts();
      // window.addEventListener("load", function (event) {
      //   var p = parseInt(Publish.currentPage.pageIndex)
      //   var s = parseInt(Publish.currentPage.sectionIndex)
      //   if (window["p" + p + "s" + s + "onPageEnter"]) {
      //     window["p" + p + "s" + s + "onPageEnter"]()
      //   }
      // });

      this.buildSearchIndex();
      this.resetSectionIndices();
    }
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = "http://quins.pblsh.media/membership18/static/_thumbs/" + (this.currentPage.index + 1) + '.png';
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'http://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cd86368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch},attrs:{"id":"app"}},[(_vm.isMobile && _vm.mobileSwitch)?[_c('mobile-container')]:[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + '-' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e(),_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("K1ID")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';

var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: '/membership18',
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js




/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
      router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
        // console.log(payload)
        context.commit('CHANGE_SECTION_INDEX', {
          pageIndex: payload.pageIndex - 1,
          sectionIndex: payload.sectionIndex - 1
        });
      });
    } else {
      // console.log('Page does not exist')
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 60;
    if (context.getters.isMobile) windowHeight = payload.height - 40;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      context.commit('UPDATE_PAGE_SCALE', { pageScale: 1 });
    } else {
      var newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == 'Contents';
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == 'Languages';
  },
  showSearch: function showSearch(state) {
    return state.activePanel == 'Search';
  },
  isZoomed: function isZoomed(state) {
    return state.activePanel == 'Zoom';
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + '/static/_content/' + state.document.companyLogo;
    } else return getters.basePath + '/static/kp-logo-white.svg';
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return '/' + pageIndex + '-' + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          currentPage: getters.currentPage,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          leftPage: null,
          currentPage: getters.currentPage,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        currentPage: getters.currentPage,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage,
        previousSection: getters.previousSection,
        nextSection: getters.nextSection
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[getters.zeroedSectionIndex]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[getters.zeroedSectionIndex]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[getters.zeroedSectionIndex]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[getters.zeroedSectionIndex]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[getters.zeroedSectionIndex]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[getters.zeroedSectionIndex]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) return getters.routeFromIndex(Math.ceil(getters.pageIndex - 2), 1);
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null) return null;
    if (state.isDoublePage && getters.doublePage) return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: 'scale(' + getters.pageContainerZoomLevel * state.pageScale + ')'
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + 'px ' + state.zoomOriginY + 'px';
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + '-' + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join('\n');
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return '/' + (pageLink.index + 1) + '-' + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },
  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      });
    };
  }

  //#endregion

  //#region doublePage 


  //#endregion

});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.activePanel = 'Zoom';
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  if (state.zoomLevel != 1) {
    state.activePanel = 'Zoom';
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "basePath": "/membership18",
  "title": "Harlequins Membership 2018/19",
  "shortTitle": "",
  "description": "Become an official member and get access to a range of exclusive benefits for the 2018/19 season.",
  "width": 1041,
  "height": 734,
  "currentLanguage": "EN",
  "companyLogo": "quins-logo.png",
  "languages": [],
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": false,
    "mobileSwitch": false,
    "downloadPath": "/membership18/static/quins-membership18.pdf"
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      <img id=\"1-t1\" class=\"1-text halfScaleR\" src=\"/membership18/static/_content/1-t1.png\" style=\"top: 40px; right: 37px;\">\n      <img id=\"1-t2\" class=\"1-text halfScaleR\" src=\"/membership18/static/_content/1-t2.png\" style=\"top: 130px; right: 39px;\">\n      <img id=\"1-sub\" class=\"1-text halfScaleR\" src=\"/membership18/static/_content/1-sub.png\" style=\"top: 186px; right: 34px;\">\n      <img id=\"1-logo\" class=\"halfScaleR\" src=\"/membership18/static/_content/1-logo.png\" style=\"top: 284px; right: 41px;\">\n      <div class=\"addContentLink\" style=\"top: 641px; left: 29px; width: 229px; height: 64px;\">\n        <a href=\"http://www.quins.co.uk/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          page1Enter = new TimelineMax()\n          page1Enter\n          .staggerFromTo(cOf('1-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5)\n          .fromTo(idOf('1-logo'), 0.5, {scale: 0, opacity: 0}, {scale:0.5, opacity: 1, onComplete:addContentLinks})\n        }\n\n        function onPageLeave() {\n          page1Enter.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "UNITED\nWE STAND\nHARLEQUINS\nMEMBERSHIP\n2018/19\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Welcome",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.png",
    "zoom": null,
    "content": "\n      <img id=\"2-t1\" class=\"halfScale\" src=\"/membership18/static/_content/2-t1.png\" style=\"top: 48px; left: 49px;\">\n      <img id=\"2-text-1\" class=\"2-text halfScale\" src=\"/membership18/static/_content/2-text-1.png\" style=\"top: 164px; left: 49px;\">\n      <img id=\"2-text-2\" class=\"2-text halfScale\" src=\"/membership18/static/_content/2-text-2.png\" style=\"top: 314px; left: 49px;\">\n      <img id=\"2-text-3\" class=\"2-text halfScale\" src=\"/membership18/static/_content/2-text-3.png\" style=\"top: 315px; left: 325px;\">\n      <img id=\"2-text-4\" class=\"2-text halfScaleB\" src=\"/membership18/static/_content/2-text-4.png\" style=\"bottom: 120px; left: 613px;\">\n      <img id=\"2-name-1\" class=\"2-text halfScaleB\" src=\"/membership18/static/_content/2-name-1.png\" style=\"bottom: 90px; left: 614px;\">\n      <img id=\"2-name-2\" class=\"2-text halfScaleBR\" src=\"/membership18/static/_content/2-name-2.png\" style=\"bottom: 70px; right: 341px;\">\n      ",
    "script": "\n        function onPageEnter() {\n          page2Enter = new TimelineMax();\n        \n          page2Enter\n            .fromTo(idOf('2-t1'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.5)\n            .staggerFromTo(cOf('2-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5)\n        }\n\n        function onPageLeave() {\n          page2Enter.stop()\n        }\n      ",
    "searchText": "WELCOME\nThese are exciting times for rugby and for our Club.\n\nWherever you look, be it at international or domestic level, our great\ngame is growing and impacting on countries and communities across\nthe world. At the heart of our game’s progress are its values: teamwork,\nrespect, enjoyment, discipline and sportsmanship. These resonate\nreadily with people of all ages and cultures fuelling an exciting prospect\nthat we are proud to be part of.\nHaving recently celebrated our 150th\nanniversary, we are very alert to the need\nto build on the legacy we have inherited\nand are doing so while coping with the\nchallenges that professional sport daily\nconfronts us with.\nOur Members know that we are\ncompeting in what is acknowledged\nto be the most competitive rugby\nleague in the world. We have a squad\nthat is in transition, and while this brings\ntemporary frustration, that is counterbalanced by the anticipation\nof what we are building. The future\nis bright – our rugby pathways are\nas strong as ever and we’re excited about\nthe development of our Girls\nand Ladies squads.\n\n2\n\nCreating the off-field structures that enable\nus to improve on it continues to be a priority.\nLast November we announced our intention\nto redevelop The Stoop and that exploratory\nwork is ongoing.\nWith each passing season we are more and\nmore aware of our role in society and in our\nlocal community. We have embarked on\nambitious programmes with community\nclubs and schools, in the process ensuring\nparity for girls, and are addressing issues\nsuch as mental health and nutrition through\nour Foundation.\nOur Members underpin all the important\nwork the Club is undertaking. Your loyalty\nand passion fuel the heartbeat that\nenergises all that we do. By becoming a\nMember or renewing your membership for\nthe 2018/19 season, you will play a crucial\nrole in the ongoing success of Harlequins.\n\nThank you for your support.\nI look forward to welcoming you\nback to The Stoop next season.\n\nDavid Ellis\nChief Executive\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "What Is Membership?",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.png",
    "zoom": null,
    "content": "\n      <img id=\"3-t1\" class=\"halfScale\" src=\"/membership18/static/_content/3-t1.png\" style=\"top: 50px; left: 44px;\">\n      <img id=\"3-sub\" class=\"3-text halfScale\" src=\"/membership18/static/_content/3-sub.png\" style=\"top: 235px; left: 49px;\">\n      <img id=\"3-text-1\" class=\"3-text halfScale\" src=\"/membership18/static/_content/3-text-1.png\" style=\"top: 353px; left: 209px;\">\n      <img id=\"3-text-2\" class=\"3-text halfScale\" src=\"/membership18/static/_content/3-text-2.png\" style=\"top: 354px; left: 530px;\">\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage({pageIndex: 5,sectionIndex: 1})\" style=\"top: 313px;left: 344px;width: 59px;height: 24px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage({pageIndex: 14,sectionIndex: 1})\" style=\"top: 637px;left: 596px;width: 20px;height: 24px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage({pageIndex: 15,sectionIndex: 1})\" style=\"top: 637px;left: 642px;width: 20px;height: 24px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          page3Enter = new TimelineMax();\n        \n          page3Enter\n            .fromTo(idOf('3-t1'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.5)\n            .staggerFromTo(cOf('3-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5, addContentLinks)\n        }\n\n        function onPageLeave() {\n          page3Enter.stop()\n        }\n      ",
    "searchText": "WHAT IS\nMEMBERSHIP?\nNot only does full membership guarantee your seat for all 16\nregular season Premiership, European and Anglo-Welsh Cup\nhome matches over the 2018/19 season, it puts you at the\nheart of our great club with access to a range of other exciting\nbenefits, details of which can be found on page 5.\nWhich membership is best for me?\n\nEach week The Stoop opens its gates to\nfamilies, groups and individuals of all ages\nand we’ve ensured that we’ve tailored our\nmembership to suit all our Members.\nFamily membership\nWe pride ourselves on the family friendly\nenvironment that The Stoop offers, with excitement\nto keep the whole family entertained on and off\nthe pitch. Our family memberships provide great\nvalue for money and range from combinations\nof one adult and one child up to two adults and\ntwo children – with every combination in between.\nFamily memberships start from £375.\nMost affordable\nOur Jester membership packages start from\njust £210 which works out as little as £13.13\nper match or £17.50 per month when paying\n\nby 12 monthly Direct Debit\ninstalments. Jester seats are\navailable in all four stands and offer\nthe most affordable membership.\nBest seats in the house\nOur Gold and Premier categories give the\nbest view of the action with seats along\neach of the touchlines, as well as access\nto the exclusive Members’ Bar where you\ncan enjoy a drink and Q\&As from players.\nHospitality\nMake your matchday even more special by\nupgrading your membership to one of our\nhospitality packages and enjoy the match\nfrom the comfort of a private box or one of our\nshared lounges. For more information please\nsee pages 14 and 15.\n\n3\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "What Does Membership Offer Me?",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.png",
    "zoom": null,
    "content": "\n      <img id=\"4-t1\" class=\"4-text halfScale\" src=\"/membership18/static/_content/4-t1.png\" style=\"top: 158px; left: 46px;\">\n      <img id=\"4-t2\" class=\"4-text halfScale\" src=\"/membership18/static/_content/4-t2.png\" style=\"top: 228px; left: 49px;\">\n      <img id=\"4-t3\" class=\"4-text halfScale\" src=\"/membership18/static/_content/4-t3.png\" style=\"top: 298px; left: 47px;\">\n      <img id=\"4-sub\" class=\"4-text halfScale\" src=\"/membership18/static/_content/4-sub.png\" style=\"top: 380px; left: 47px;\">\n      <img id=\"4-quote\" class=\"halfScale\" src=\"/membership18/static/_content/4-quote.png\" style=\"top: 495px; left: 49px;\">\n      ",
    "script": "\n        function onPageEnter() {\n          page4Enter = new TimelineMax();\n        \n          page4Enter\n          .staggerFromTo(cOf('4-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5)\n          .fromTo(idOf('4-quote'), 0.5, {scale: 0, opacity: 0}, {scale: 0.5, opacity: 1})\n        }\n\n        function onPageLeave() {\n          page4Enter.stop()\n        }\n      ",
    "searchText": "WHAT DOES\nMEMBERSHIP\nOFFER ME?\n\nAs well as your seat for every regular\nseason match at The Stoop, you’ll also\nreceive a range of benefits and rewards.\nThis was our first season as Members and we\ncan honestly say it’s been fantastic in every way.\nThe Stoop has such a great atmosphere and it’s\nbeen really fun to enjoy as a whole family. Our son\nwas also lucky to be a mascot which was the most\nincredible and memorable experience that will be\ncherished for a long time. Thank you Quins.\nCharlotte, Member\n\n4\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Membership Benefits",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.png",
    "zoom": null,
    "content": "\n      <img id=\"5-t1\" class=\"5-text halfScale\" src=\"/membership18/static/_content/5-t1.png\" style=\"top: 50px; left: 369px;\">\n      <img id=\"5-quote\" class=\"5-quote halfScale\" src=\"/membership18/static/_content/5-quote.png\" style=\"top: 385px; left: 49px;\">\n      <img id=\"5-text-1\" class=\"5-text halfScale\" src=\"/membership18/static/_content/5-text-1.png\" style=\"top: 164px; left: 368px;\">\n      <img id=\"5-text-2\" class=\"5-text halfScale\" src=\"/membership18/static/_content/5-text-2.png\" style=\"top: 241px; left: 369px;\">\n      <img id=\"5-text-4\" class=\"5-text halfScale\" src=\"/membership18/static/_content/5-text-3.png\" style=\"top: 319px; left: 369px;\">\n      <img id=\"5-text-5\" class=\"5-text halfScale\" src=\"/membership18/static/_content/5-text-4.png\" style=\"top: 362px; left: 369px;\">\n      <img id=\"5-text-6\" class=\"5-text halfScale\" src=\"/membership18/static/_content/5-text-5.png\" style=\"top: 406px; left: 369px;\">\n      <img id=\"5-text-7\" class=\"5-text halfScale\" src=\"/membership18/static/_content/5-text-6.png\" style=\"top: 449px; left: 369px;\">\n      <img id=\"5-text-8\" class=\"5-text halfScale\" src=\"/membership18/static/_content/5-text-7.png\" style=\"top: 164px; left: 670px;\">\n      <img id=\"5-text-9\" class=\"5-text halfScale\" src=\"/membership18/static/_content/5-text-8.png\" style=\"top: 235px; left: 670px;\">\n      <img id=\"5-terms\" class=\"5-text halfScale\" src=\"/membership18/static/_content/5-terms.png\" style=\"top: 603px; left: 671px;\">\n      ",
    "script": "\n        function onPageEnter() {\n          page5Enter = new TimelineMax();\n        \n          page5Enter\n          .staggerFromTo(cOf('5-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5)\n          .fromTo(idOf('5-quote'), 0.5, {scale: 0, opacity: 0}, {scale: 0.5, opacity: 1})\n        }\n\n        function onPageLeave() {\n          page5Enter.stop()\n        }\n      ",
    "searchText": "MEMBERSHIP\nBENEFITS\n• Y\n our guaranteed seat at The Stoop for all\nregular season home matches, as well as\npre-season, A-League, Harlequins Ladies\nand England Women Test matches.\n• T\n he guaranteed right to purchase\na ticket for all knockout matches, with\nthe option to register for our Automatic\nTicket Purchase Scheme.\n• T\n icket ballot access for England Rugby\nmatches at Twickenham Stadium.*\n• A\n ticket for Big Game 11\nat Twickenham Stadium.**\n• U\n se of Ticket Forwarding and Ticket\nResale for matches you cannot attend.\n• E\n xclusive matchday cashback rewards\nwhen using eCash.\n\nNot only do you get your own\nseat for home matches which\nis fantastic. You also get the\nopportunity to attend the exclusive\nMember events at The Stoop, which\nis brilliant, as you get to talk the\nyour favourite player afterwards.\nMark, Member\n\nAdditional rewards:\n• 25% discount on guest tickets.***\n• Invitations for you and your guests to free\nand exclusive Member events featuring\nplayers and coaches.\n• E\n xclusive discount on 2018/19 replica\nhome, away and training shirts.\n• E\n xclusive offers and discounts from\nDHL, adidas, Greene King and the rest\nof our Partners.\n• 2\n 5% discount on non-matchday facilities\nat The Stoop.\nAdditional benefits for Members in Gold, Premier\nand FJ / FH Accessible Seating categories:\n• Access to the Members’ Bar.\n• 5\n 0% discounted guest ticket\nto Big Game 11.\n\n* Priority will be given to Gold and Premier Members\n**\tGold and Premier Members can select their ticket for any seating\ncategory. Club, Touchline and Jester Members can select their\nticket from Categories 1, 2 and 3. Premium category tickets can\nbe booked for an additional £10 for adults and £5 for juniors.\n***\tDiscounted tickets are limited and available on a first come, first\nserved basis. Limit of one guest ticket per Member, per match.\n\n5\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Words from Nigel Denby",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.png",
    "zoom": null,
    "content": "\n      <img id=\"6-quote\" class=\"halfScale\" src=\"/membership18/static/_content/6-quote.png\" style=\"top: 425px; left: 642px;\">\n      ",
    "script": "\n        function onPageEnter() {\n          page6Enter = new TimelineMax();\n        \n          page6Enter\n          .fromTo(idOf('6-quote'), 0.5, {scale: 0, opacity: 0}, {scale:0.5, opacity: 1}, 0.5)\n        }\n\n        function onPageLeave() {\n          page6Enter.stop()\n        }\n      ",
    "searchText": "As a new Member who travels\nfrequently, I found the online Ticket\nResale process very easy to use,\nensuring someone else could\nsupport the team in my absence.\nNigel Denby, Member\n6\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Flexibity and Rewards",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.png",
    "zoom": null,
    "content": "\n      <img id=\"7-t1\" class=\"7-text halfScale\" src=\"/membership18/static/_content/7-t1.png\" style=\"top: 50px; left: 45px;\">\n      <img id=\"7-text-1\" class=\"7-text halfScale\" src=\"/membership18/static/_content/7-text-1.png\" style=\"top: 217px; left: 50px;\">\n      <img id=\"7-text-1-2\" class=\"7-text halfScale\" src=\"/membership18/static/_content/7-text-1-2.png\" style=\"top: 243px; left: 49px;\">\n      <img id=\"7-text-2\" class=\"7-text halfScale\" src=\"/membership18/static/_content/7-text-2.png\" style=\"top: 451px; left: 49px;\">\n      <img id=\"7-text-2-2\" class=\"7-text halfScale\" src=\"/membership18/static/_content/7-text-2-2.png\" style=\"top: 496px; left: 49px;\">\n      <img id=\"7-text-3\" class=\"7-text halfScale\" src=\"/membership18/static/_content/7-text-3.png\" style=\"top: 217px; left: 371px;\">\n      <img id=\"7-text-3-2\" class=\"7-text halfScale\" src=\"/membership18/static/_content/7-text-3-2.png\" style=\"top: 262px; left: 370px;\">\n      <img id=\"7-terms\" class=\"7-text halfScale\" src=\"/membership18/static/_content/7-terms.png\" style=\"top: 403px; left: 370px;\">\n      <div class=\"addContentLink\" style=\"top: 422px; left: 369px; width: 139px; height: 24px;\">\n        <a href=\"http://www.quins.co.uk/membership\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          page7Enter = new TimelineMax();\n        \n          page7Enter\n          .staggerFromTo(cOf('7-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5, addContentLinks)\n        }\n\n        function onPageLeave() {\n          page7Enter.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "FLEXIBILITY\nAND REWARDS\nWHAT IF I CAN’T MAKE A MATCH?\nTicket Forwarding and Ticket Resale\n\nYou might not be able to make it to every match\nof the season, but you can still support the team\nby making sure someone can cheer the team\non from your seat, even when you’re not there.\nTicket Forwarding allows you to email your ticket\nto a friend in a few easy online steps, while just\nas easily, you can make your seat available\nfor sale to another supporter by using Ticket\nResale*. Make the most of your membership,\neven when you can’t be at The Stoop.\n\nHOW DO I GET MY\nMATCHDAY DISCOUNTS?\neCash\n\nYou will earn 20% cashback on every purchase\nyou make with eCash within the first hour\nof gates opening, including food, drinks and\nmerchandise. You can top up your eCash\nbalance online and set up an automatic\ntop-up payment for even more convenience.\n*S ubject to your seating category reaching 90% ticket\ncapacity. Please see Terms and Conditions at\nquins.co.uk/membership for more information.\n\nWHAT IF THE MATCH IS TOO LATE\nFOR MY KIDS TO ATTEND?\nMighty Quins Upgrades\n\nIf a match kicks off after 19:00 and it’s too late\nfor your Mighty Quins (Members aged under 16)\nto attend, you can bring an adult in their place\nat no extra cost.\n\n7\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Optional Benefits",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.png",
    "zoom": null,
    "content": "\n      <img id=\"8-t1\" class=\"8-text halfScale\" src=\"/membership18/static/_content/8-t1.png\" style=\"top: 230px; left: 48px;\">\n      <img id=\"8-t2\" class=\"8-text halfScale\" src=\"/membership18/static/_content/8-t2.png\" style=\"top: 311px; left: 49px;\">\n      <img id=\"8-text-1\" class=\"8-text halfScale\" src=\"/membership18/static/_content/8-text-1.png\" style=\"top: 409px; left: 49px;\">\n      <img id=\"8-text-2\" class=\"8-text halfScale\" src=\"/membership18/static/_content/8-text-2.png\" style=\"top: 503px; left: 49px;\">\n      <img id=\"8-text-3\" class=\"8-text halfScale\" src=\"/membership18/static/_content/8-text-3.png\" style=\"top: 407px; left: 370px;\">\n      <img id=\"8-text-4\" class=\"8-text halfScale\" src=\"/membership18/static/_content/8-text-4.png\" style=\"top: 517px; left: 370px;\">\n      <div class=\"addContentLink\" style=\"top: 472px; left: 186px; width: 119px; height: 24px;\">\n        <a href=\"http://www.quinssa.co.uk\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          page8Enter = new TimelineMax();\n          page8Enter\n          .staggerFromTo(cOf('8-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5, addContentLinks)\n        }\n\n        function onPageLeave() {\n          page8Enter.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "OPTIONAL\nBENEFITS\nQuinssa\nYou can become a Member of the official Quins\nSupporters’ Association for just £5. For more\ninformation on everything Quinssa offers its\nmembers, please visit Quinssa.org.uk.\nFan Radio\nFan Radio delivers the referee’s decisions and\nmatch commentary straight to your seat, via a\nHarlequins branded radio that costs just £15\nfor the season. Fan Radio is available for all\nPremiership matches, including Big Game 11, as\nwell as European and Anglo-Welsh Cup fixtures.\nPlease note, Fan Radios used in the 2017/18\nseason cannot be used for 2018/19. If you would\nlike a Fan Radio for the new season, please\npurchase one with your membership.\n8\n\nCar Parking\nFor those Members unable to use public\ntransport to travel to The Stoop, seasonal\nparking is available for £49 for Gold and\nPremier Members or £99 for Club, Touchline\nand Jester Members.\nDigital Matchday Programme\nYou can download each and every matchday\nprogramme to your mobile device on the way to\nThe Stoop by buying a seasonal subscription\nto our digital matchday programme for just £15.\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "What Else Do I Need To Know?",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.png",
    "zoom": null,
    "content": "\n        <img id=\"9-t1\" class=\"9-text halfScale\" src=\"/membership18/static/_content/9-t1.png\" style=\"top: 50px; left: 45px;\">\n        <img id=\"9-text-1\" class=\"9-text halfScale\" src=\"/membership18/static/_content/9-text-1.png\" style=\"top: 211px; left: 50px;\">\n        <img id=\"9-text-2\" class=\"9-text halfScale\" src=\"/membership18/static/_content/9-text-2.png\" style=\"top: 304px; left: 50px;\">\n        <img id=\"9-text-3\" class=\"9-text halfScale\" src=\"/membership18/static/_content/9-text-3.png\" style=\"top: 211px; left: 369px;\">\n        <img id=\"9-text-4\" class=\"9-text halfScale\" src=\"/membership18/static/_content/9-text-4.png\" style=\"top: 468px; left: 369px;\">\n        <img id=\"9-text-5\" class=\"9-text halfScale\" src=\"/membership18/static/_content/9-text-5.png\" style=\"top: 613px; left: 369px;\">\n        <img id=\"9-text-5-2\" class=\"9-text halfScale\" src=\"/membership18/static/_content/9-text-5-2.png\" style=\"top: 211px; left: 690px;\">\n        <img id=\"9-text-6\" class=\"9-text halfScale\" src=\"/membership18/static/_content/9-text-6.png\" style=\"top: 276px; left: 690px;\">\n        <img id=\"9-text-7\" class=\"9-text halfScale\" src=\"/membership18/static/_content/9-text-7.png\" style=\"top: 466px; left: 690px;\">\n        <img id=\"9-text-8\" class=\"9-text halfScale\" src=\"/membership18/static/_content/9-text-8.png\" style=\"top: 552px; left: 690px;\">\n          <div class=\"addContentLink\" style=\"top: 271px; left: 49px; width: 179px; height: 24px;\">\n            <a href=\"http://www.quins.co.uk/membership\" target=\"_blank\"></a>\n          </div>\n        <div class=\"addContentLink\" style=\"top: 364px; left: 687px; width: 139px; height: 24px;\">\n          <a href=\"http://tickets.quins.co.uk\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          page9Enter = new TimelineMax();\n          page9Enter\n          .staggerFromTo(cOf('9-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5, addContentLinks)\n        }\n\n        function onPageLeave() {\n          page9Enter.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "WHAT ELSE DO I\nNEED TO KNOW?\nThe simplest way to renew your\nmembership or become a Member\nfor the first time is online, by visiting\nquins.co.uk/membership.\nWhen you buy your membership online,\nyou’ll also be entered into a free draw to\nwin a number of prizes, including signed\nboots, shirts and balls and even the chance\nto appear in the squad photo for the new\nseason. The earlier you join for 2018/19,\nthe more chances you have to win.\n\nIt’s better together\nWhether you and friends became Members\ntogether or you’ve become friends with those\naround you over the years, you know that\na day at The Stoop is even better when you\ncelebrate together.\nIf you introduce people to membership at\nHarlequins, whether they’re friends, family or\ncolleagues, you will receive a £40 eCash credit\nto spend at The Stoop and they will receive £25.\nMember renewal deadline and moving seats\nAs an existing Member, your current seat will\nbe reserved for you until Wednesday 23 rd May.\nOn Thursday 24th May, you will have an\nexclusive window within which you can move\nyour seat if you wish to do so. From Friday\n25th May, all un-renewed seats will be put\non general sale.\nNew: 2018/19 waiting list\nTo ensure we can still offer a range of seats\nfor matchday ticket purchasers, this season\nwe will be capping membership at 9,500. A\nwaiting list will be created for any supporters\nwanting to become Members once the cap\nhas been reached.\n\nBig Game 11\nA seat at Big Game 11 at Twickenham Stadium\nis included in membership. Please note that this\nyear Gold and Premier Members can select their\nticket for any seating category. Club, Touchline\nand Jester Members can select their ticket from\nCategories 1, 2 and 3. Premium category tickets\ncan be booked for an additional £10 for adults\nand £5 for juniors.\nTickets will be available in the summer\nby calling us on 020 8410 6010 or visiting\ntickets.quins.co.uk. We will be reserving\nMember seats until Friday 21st October,\nafter which Members will be able to claim their\nseats elsewhere in the stadium but we cannot\nguarantee a seat will be reserved for you.\nMembers’ Bar\nAs with previous years, Gold and Premier\nMembers will have access to the Members’\nBar on matchday, located in the IG Stand.\nDirect Debit\nPaying by Direct Debit means you can spread\nthe cost of your membership over up to 12\ninterest-free months. You can set up a Direct\nDebit plan online and over the telephone when\nyou join as a Member.\n\n9\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Family And Junior Memberships",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.png",
    "zoom": null,
    "content": "\n      <img id=\"10-t1\" class=\"10-text halfScale\" src=\"/membership18/static/_content/10-t1.png\" style=\"top: 245px; left: 49px;\">\n      <img id=\"10-t2\" class=\"10-text halfScale\" src=\"/membership18/static/_content/10-t2.png\" style=\"top: 320px; left: 43px;\">\n      <img id=\"10-t3\" class=\"10-text halfScale\" src=\"/membership18/static/_content/10-t3.png\" style=\"top: 397px; left: 49px;\">\n      <img id=\"10-text-1\" class=\"10-text halfScale\" src=\"/membership18/static/_content/10-text-1.png\" style=\"top: 492px; left: 49px;\">\n      <img id=\"10-terms\" class=\"10-text halfScale\" src=\"/membership18/static/_content/10-terms.png\" style=\"top: 667px; left: 48px;\">\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage({pageIndex: 16,sectionIndex: 1})\" style=\"top: 664px;left: 44px;width: 189px;height: 28px;\"></div>\n      <svg class=\"abs pulse animatedpulse pointer\" onclick=\"Publish.updateVideoURL('https://www.youtube.com/embed/JsY0Tqy-PDw?autoplay=1')\" style=\"width:45px; height:45px;left:49px;top:71px\"version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n            width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n        <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n        <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n      </svg>\n      ",
    "script": "\n        function onPageEnter() {\n          page10Enter = new TimelineMax();\n        \n          page10Enter\n          .staggerFromTo(cOf('10-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5, addContentLinks)\n        }\n\n        function onPageLeave() {\n          page10Enter.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "FAMILY\nAND JUNIOR\nMEMBERSHIPS\nLast season our youngest Member was just ten months old and\nour most senior Member is still supporting the team week in\nweek out aged 99. There really is something for all ages to enjoy\nat Harlequins and our matchdays wouldn’t be the same without\nthe support from our families and Mighty Quins Junior Members.\nStarting from just £375, family membership offers fantastic value\nand allows you all to share the excitement together.\nA full breakdown on the range of family\npackages can be found on page 16.\n\n10\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Anything for Junior Members?",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.png",
    "zoom": null,
    "content": "\n      <img id=\"11-t1\" class=\"11-text halfScale\" src=\"/membership18/static/_content/11-t1.png\" style=\"top: 182px; left: 47px;\">\n      <img id=\"11-text-1\" class=\"11-text halfScale\" src=\"/membership18/static/_content/11-text-1.png\" style=\"top: 385px; left: 49px;\">\n      <img id=\"11-text-2\" class=\"11-text halfScale\" src=\"/membership18/static/_content/11-text-2.png\" style=\"top: 386px; left: 370px;\">\n      <img id=\"11-text-3\" class=\"11-text halfScale\" src=\"/membership18/static/_content/11-text-3.png\" style=\"top: 446px; left: 370px;\">\n      ",
    "script": "\n        function onPageEnter() {\n          page11Enter = new TimelineMax();\n        \n          page11Enter\n          .staggerFromTo(cOf('11-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5)\n        }\n\n        function onPageLeave() {\n          page11Enter.stop()\n        }\n      ",
    "searchText": "IS THERE ANYTHING\nSPECIAL FOR JUNIOR\nMEMBERS?\nAll young supporters (aged under 16) are part\nof our Mighty Quins Club and can benefit from:\n• Ballot entry to be a matchday mascot\n• A matchday gift pack\n• C\n omplimentary match ticket to bring a friend\nto a match to celebrate a birthday\n• Invitation to the Mighty Quins Christmas party,\nattended by players and Father Christmas\n• A squad poster\n\nWhen Mighty Quins graduate to Adult membership\nat 16, they will qualify for Concession pricing until\nthey are 22.\nMeet the players\nOur players love meeting our Mighty Quins\nJunior Members and the pre-match meet and\ngreets in the South West Corner and post-match\nautograph and question and answer sessions\nprovide plenty of opportunities for you to talk\nto your heroes and discuss the highlights from\nthe match.\n\n• B\n irthday and Christmas cards from\nthe Club Captain\n• If an evening match kicks off after 19:00,\ntheir seat can be upgraded for use by\nan adult at no extra cost\n\n11\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Words from Rachael Burford",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.png",
    "zoom": null,
    "content": "\n      <img id=\"12-quote\" class=\"halfScale\" src=\"/membership18/static/_content/12-quote.png\" style=\"top: 297px; left: 530px;\">\n      ",
    "script": "\n        function onPageEnter() {\n          page12Enter = new TimelineMax();\n          page12Enter.fromTo(idOf('12-quote'), 0.5, {scale: 0, opacity: 0}, {scale:0.5, opacity: 1}, 0.5);\n        }\n\n        function onPageLeave() {\n          page12Enter.stop();\n        }\n      ",
    "searchText": "It’s been a successful first season for the Tyrell’s\nPremier 15s competition and the women’s\ngame is going from strength to strength in this\ncountry with the Club leading the way. We’ve\nhad great support at our matches at Surrey\nSports Park and especially at The Stoop, where\nwe love playing. We’re excited to be playing\neven more matches there next season and are\nlooking forward to seeing plenty of Members\nin the stands cheering us on.\nRachael Burford, Harlequins Captain\n12\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Harlequins Ladies",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.png",
    "zoom": null,
    "content": "\n      <img id=\"13-t1\" class=\"13-text halfScale\" src=\"/membership18/static/_content/13-t1.png\" style=\"top: 49px; left: 49px;\">\n      <img id=\"13-text-1\" class=\"13-text halfScale\" src=\"/membership18/static/_content/13-text-1.png\" style=\"top: 208px; left: 49px;\">\n      <img id=\"13-text-2\" class=\"13-text halfScale\" src=\"/membership18/static/_content/13-text-2.png\" style=\"top: 277px; left: 49px;\">\n      <img id=\"13-text-3\" class=\"13-text halfScale\" src=\"/membership18/static/_content/13-text-3.png\" style=\"top: 277px; left: 289px;\">\n      ",
    "script": "\n        function onPageEnter() {\n          page13Enter = new TimelineMax();\n          page13Enter.staggerFromTo(cOf('13-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5);\n        }\n\n        function onPageLeave() {\n          page13Enter.stop();\n        }\n      ",
    "searchText": "HARLEQUINS\nLADIES\nThe inaugural Tyrells Premier 15s season has seen Harlequins\nLadies excite supporters at The Stoop and Surrey Sports Park\nwith running rugby, thrilling tries and impressive victories.\nThe Club’s commitment to growing\nthe women’s game and offering\na pathway from grassroots –\nwhere our Switch programme has\nintroduced 1000 girls to rugby this\nyear – to the elite level, has been\nexemplified by the first team squad\nthis season.\n\nWith even more Harlequins Ladies\nmatches to be played at The Stoop\nnext season, as well as England\nWomen Test matches all included\nin membership, you’ll have plenty\nof opportunities to watch women’s\nrugby continue to go from\nstrength to strength.\n\nSeasoned internationals such\nas Rachael Burford have played\nalongside teammates like Shaunagh\nBrown, who made her England\ndebut in the autumn, and Jess\nBreach who has recently signed\na professional sevens contact with\nEngland Rugby.\n\n13\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "What If I Want More?",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.png",
    "zoom": null,
    "content": "\n      <img id=\"14-t1\" class=\"14-text halfScale\" src=\"/membership18/static/_content/14-t1.png\" style=\"top: 130px; left: 39px;\">\n      <img id=\"14-t2\" class=\"14-text halfScale\" src=\"/membership18/static/_content/14-t2.png\" style=\"top: 213px; left: 50px;\">\n      <img id=\"14-text-1\" class=\"14-text halfScale\" src=\"/membership18/static/_content/14-text-1.png\" style=\"top: 317px; left: 50px;\">\n      <img id=\"14-text-2\" class=\"14-text halfScale\" src=\"/membership18/static/_content/14-text-2.png\" style=\"top: 383px; left: 50px;\">\n      <img id=\"14-text-3\" class=\"14-text halfScale\" src=\"/membership18/static/_content/14-text-3.png\" style=\"top: 383px; left: 370px;\">\n      <img id=\"14-text-4\" class=\"14-text halfScale\" src=\"/membership18/static/_content/14-text-4.png\" style=\"top: 487px; left: 370px;\">\n      <div class=\"addContentLink\" style=\"top: 592px; left: 363px; width: 178px; height: 24px;\">\n        <a href=\"mailto:hospitality@quins.co.uk\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          page14Enter = new TimelineMax();\n        \n          page14Enter\n          .staggerFromTo(cOf('14-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5, addContentLinks)\n        }\n\n        function onPageLeave() {\n          page14Enter.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "WHAT IF I\nWANT MORE?\nNew for the 2018/19 season, the 1866 Lounge is our entry level\npackage and brings a fresh take on relaxed rugby hospitality.\n\nBenefits:\n• G\n et together with friends or entertain clients\nin this informal and social space.\n• N\n ever miss a moment with seats between\nthe 22 and the try line.\n• E\n njoy a variety of sharing plates and boards\npre-match, with a selection of cheeses and\ndesserts served at half time.\n• A\n fully inclusive bar of beer, wine and soft\ndrinks until kick-off, with the Drink Of The\nDay at half time and a cash bar available\npost-match.\n• C\n hoose from a ticket to Big Game 11 at\nTwickenham Stadium or a 50% Discount\nagainst a hospitality upgrade.\n14\n\n• M\n eet and take photos with Harlequins\nplayers throughout the season.\n• G\n et guests excited about joining you at\nThe Stoop by sending them their Digital\nProgramme pre-match.\nPrice: £1,866 Per Person + VAT\nfor the full season.\nFor more information on our 1866 Lounge\nof any of our other Hospitality options, please\ncontact the Harlequins Hospitality Team on:\n020 8410 6049\nhospitality@quins.co.uk\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.png",
    "zoom": null,
    "content": "",
    "script": null,
    "searchText": "15\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Pricing",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16z.jpg",
    "zoom": null,
    "content": "\n      <img id=\"16-t1\" class=\"16-text halfScale\" src=\"/membership18/static/_content/16-t1.png\" style=\"top: 70px; left: 61px;\">\n      <img id=\"16-t2\" class=\"16-text halfScale\" src=\"/membership18/static/_content/16-t2.png\" style=\"top: 459px; left: 60px;\">\n      <img id=\"16-text-1\" class=\"16-text halfScale\" src=\"/membership18/static/_content/16-text-1.png\" style=\"top: 663px; left: 58px;\">\n      ",
    "script": "\n        function onPageEnter() {\n          page16Enter = new TimelineMax();\n        \n          page16Enter\n          .staggerFromTo(cOf('16-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5)\n        }\n\n        function onPageLeave() {\n          page16Enter.stop()\n        }\n      ",
    "searchText": "PRICING\nADULT\n\nJUNIOR\n\nCONCESSION*\n\nRenewal\n\nDEBENTURE\n\nRenewal\n\nNew\n\nRenewal\n\nNew\n\nNew\n\nRenewal\n\nGOLD\n\n£690\n\n£735\n\n£690\n\n£735\n\n–\n\n–\n\n£345\n\nPREMIER\n\n£570\n\n£650\n\n£260\n\n£650\n\n–\n\n–\n\n£285\n\nCLUB\n\n£450\n\n£495\n\n£175\n\n£205\n\n£335\n\n£380\n\n–\n\nTOUCHLINE\n\n£335\n\n£375\n\n£160\n\n£185\n\n£220\n\n£265\n\n–\n\nJESTER\n\n£210\n\n£280\n\n£110\n\n£110\n\n£180\n\n£215\n\n–\n\nWHEELCHAIR\n\n£325\n\n£360\n\n£215\n\n£245\n\n£325\n\n£360\n\n–\n\nWHEELCHAIR\nPITCH LEVEL\n\n£245\n\n£275\n\n£140\n\n£160\n\n£245\n\n£275\n\n–\n\nFAMILY PRICING\n1 ADULT + 1 JUNIOR\n\nRenewal\n\n16\n\nNew\n–\n\n2 ADULT + 1 JUNIOR\n\nRenewal\n£1,165\n\nNew\n–\n\n1 ADULT + 2 JUNIOR\n\nRenewal\n£905\n\n2 ADULT + 2 JUNIOR**\n\nNew\n\nRenewal\n\nNew\n\n–\n\n£1,240\n\n–\n\nPREMIER\n\n£625\n\nCLUB\n\n£470\n\n£535\n\n£920\n\n£1,020\n\n£665\n\n£785\n\n£940\n\n£1,070\n\nTOUCHLINE\n\n£375\n\n£435\n\n£685\n\n£805\n\n£545\n\n£640\n\n£760\n\n£865\n\nCOMMUNITY AND LOCAL BUSINESS MEMBERSHIP\nIf you are part of one of our Community Clubs or are buying on behalf of a local business in Twickenham or Richmond,\nplease give us a call on 020 8410 6010 to talk through the bespoke membership options that are available to you.\n\n*T he following groups qualify\nfor Concession membership:\n• 16-21 year olds\n• Seniors (aged 65+)\n• Key Workers and Armed Forces\n• Full Time Students\n**If your family group exceeds\nthe 2 Adults + 2 Junior package,\nplease call us on 020 8410 6010\nto discuss package pricing.\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Stoop Map",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17z.jpg",
    "zoom": null,
    "content": "\n        <svg class=\"abs pointer pulse animatedpulse \" style=\"left:366px;width:40px; top:389px; height:40px\" width=\"160.62px\" height=\"157.733px\" viewBox=\"0 0 160.62 157.733\" enable-background=\"new 0 0 160.62 157.733\" onclick=\"showOverlay('17-overlay-1')\">\n        <g>\n        <path fill=\"#fff\" d=\"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n          c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z\"></path>\n        <path fill=\"#fff\" d=\"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n          c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n          h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n          c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n          M123.685,63.134h-20.209v-5.966h20.209V63.134z\"></path>\n        </g>\n        <g>\n        <path fill=\"#fff\" d=\"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n          c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n          c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n          c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n          c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n          c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n          c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n          C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n          c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n          c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n          c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n          L154.856,78.867z\"></path>\n        </g>\n        </svg>\n        <svg class=\"abs pointer pulse animatedpulse \" style=\"left:236px;width:40px; top:343px; height:40px\" width=\"160.62px\" height=\"157.733px\" viewBox=\"0 0 160.62 157.733\" enable-background=\"new 0 0 160.62 157.733\" onclick=\"showOverlay('17-overlay-2')\">\n          <g>\n              <path fill=\"#fff\" d=\"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                  c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z\"></path>\n              <path fill=\"#fff\" d=\"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                  c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                  h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                  c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                   M123.685,63.134h-20.209v-5.966h20.209V63.134z\"></path>\n          </g>\n          <g>\n              <path fill=\"#fff\" d=\"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                  c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                  c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                  c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                  c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                  c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                  c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                  C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                  c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                  c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                  c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                  L154.856,78.867z\"></path>\n          </g>\n          </svg>\n          <svg class=\"abs pointer pulse animatedpulse \" style=\"left:809px;width:40px; top:344px; height:40px\" width=\"160.62px\" height=\"157.733px\" viewBox=\"0 0 160.62 157.733\" enable-background=\"new 0 0 160.62 157.733\" onclick=\"showOverlay('17-overlay-3')\">\n          <g>\n              <path fill=\"#fff\" d=\"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                  c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z\"></path>\n              <path fill=\"#fff\" d=\"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                  c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                  h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                  c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                   M123.685,63.134h-20.209v-5.966h20.209V63.134z\"></path>\n          </g>\n          <g>\n              <path fill=\"#fff\" d=\"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                  c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                  c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                  c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                  c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                  c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                  c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                  C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                  c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                  c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                  c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                  L154.856,78.867z\"></path>\n          </g>\n          </svg>\n          <svg class=\"abs pointer pulse animatedpulse \" style=\"left:523px; width:40px; top:576px; height:40px\" width=\"160.62px\" height=\"157.733px\" viewBox=\"0 0 160.62 157.733\" enable-background=\"new 0 0 160.62 157.733\" onclick=\"showOverlay('17-overlay-4')\">\n          <g>\n              <path fill=\"#fff\" d=\"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                  c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z\"></path>\n              <path fill=\"#fff\" d=\"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                  c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                  h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                  c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                   M123.685,63.134h-20.209v-5.966h20.209V63.134z\"></path>\n          </g>\n          <g>\n              <path fill=\"#fff\" d=\"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                  c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                  c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                  c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                  c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                  c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                  c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                  C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                  c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                  c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                  c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                  L154.856,78.867z\"></path>\n          </g>\n          </svg>\n          <div id=\"17-overlay-1\" class=\"contentOverlay hidden noclick\" onclick=\"hideOverlay('17-overlay-1')\">\n            <img src=\"/membership18/static/_content/queens-head-bar.jpg\" class=\"centre\">\n          </div>\n          <div id=\"17-overlay-2\" class=\"contentOverlay hidden noclick\" onclick=\"hideOverlay('17-overlay-2')\">\n          <img src=\"/membership18/static/_content/south-stand.jpg\" class=\"centre\">\n          </div>\n          <div id=\"17-overlay-3\" class=\"contentOverlay hidden noclick\" onclick=\"hideOverlay('17-overlay-3')\">\n          <img src=\"/membership18/static/_content/view-from-north-stand.jpg\" class=\"centre\">\n          </div>\n          <div id=\"17-overlay-4\" class=\"contentOverlay hidden noclick\" onclick=\"hideOverlay('17-overlay-4')\">\n          <img src=\"/membership18/static/_content/view-from-east-stand.jpg\" class=\"centre\">\n          </div>\n          <svg class=\"abs pulse animatedpulse pointer\" onclick=\"Publish.updateVideoURL('https://www.youtube.com/embed/f6TvN2mFdI4?autoplay=1')\" style=\"width:45px; height:45px;left:521px;top:351px\"version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n                width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n\n          <svg class=\"abs pulse animatedpulse pointer\" onclick=\"Publish.updateVideoURL('https://www.youtube.com/embed/RMlPagGLDQM?autoplay=1')\" style=\"width:45px; height:45px;left:468px;top:291px\"version=\"1.1\" id=\"Layer_2\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n                width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n\n          <svg class=\"abs pulse animatedpulse pointer\" onclick=\"Publish.updateVideoURL('static/_content/tunnel.mp4');\" style=\"width:45px; height:45px;left:521px;top:161px\"version=\"1.1\" id=\"Layer_2\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n                width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>",
    "script": "\n        function onPageLeave() {\n          hideOverlay('17-overlay-1')\n          hideOverlay('17-overlay-2')\n          hideOverlay('17-overlay-3')\n          hideOverlay('17-overlay-4')\n        }\n      ",
    "searchText": "STOOP\nMAP\n\n17\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "How Do I Join The Team?",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.png",
    "zoom": null,
    "content": "\n      <img id=\"18-t1\" class=\"18-text halfScale\" src=\"/membership18/static/_content/18-t1.png\" style=\"top: 49px; left: 49px;\">\n      <img id=\"18-text-1\" class=\"18-text halfScale\" src=\"/membership18/static/_content/18-text-1.png\" style=\"top: 207px; left: 49px;\">\n      <img id=\"18-text-2\" class=\"18-text halfScale\" src=\"/membership18/static/_content/18-text-2.png\" style=\"top: 368px; left: 50px;\">\n      <img id=\"18-text-3\" class=\"18-text halfScale\" src=\"/membership18/static/_content/18-text-3.png\" style=\"top: 478px; left: 49px;\">\n      <img id=\"18-text-4\" class=\"18-text halfScale\" src=\"/membership18/static/_content/18-text-4.png\" style=\"top: 555px; left: 49px;\">\n      <img id=\"18-text-5\" class=\"18-text halfScale\" src=\"/membership18/static/_content/18-text-5.png\" style=\"top: 368px; left: 387px;\">\n      <img id=\"18-text-6\" class=\"18-text halfScale\" src=\"/membership18/static/_content/18-text-6.png\" style=\"top: 615px; left: 387px;\">\n      <div class=\"addContentLink\" style=\"top: 223px; left: 310px; width: 179px; height: 24px;\">\n        <a href=\"http://www.quins.co.uk/membership\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top: 681px;left: 395px; width: 119px; height: 24px;\">\n        <a href=\"http://www.quins.co.uk/membership\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          page18Enter = new TimelineMax();\n        \n          page18Enter\n          .staggerFromTo(cOf('18-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5, addContentLinks)\n        }\n\n        function onPageLeave() {\n          page18Enter.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "HOW DO I JOIN\nTHE TEAM?\nThe simplest way to renew your membership or become a Member\nfor the first time is online, by visiting quins.co.uk/membership.\nWhen you buy your membership online, you’ll also be entered into\na free draw to win a number of prizes, including signed boots, shirts\nand balls and even the chance to appear in the squad photo for the\nnew season. The earlier you join for 2018/19, the more chances\nyou have to win.*\nPlease note, if you are renewing or purchasing\nFamily or Concession Membership, you will not\nbe able to do so online. You will still be entered\ninto the prize draw. Members automatically\nrenewing by Direct Debit will be eligible for\nprizes every day.\n\n18\n\nPost\nSend your completed application form, cheque\n(made payable to Harlequin Football Club Ltd)\nand any other documents required (such as your\nproof of eligibility for Concession pricing) to:\n\nTelephone\nIf you don’t have access to the Internet, you can\nalso purchase your membership by calling\n020 8410 6010.\n\nHarlequins 2018/19 Membership,\nTwickenham Stoop Stadium,\nLanghorn Drive,\nTwickenham,\nTW2 7SX\n\nIn Person\nYou’ll be able to renew by visiting The Stoop\nMonday to Friday, from 09:00 to 16:30 or once\ngates have opened on matchdays, where you can\nvisit the internal window of the Ticket Office by Gate\n3 – The Bob Hiller Gate. Please remember to bring\nyour completed applications form(s) and proof of\neligibility for Concession pricing, if applicable.\n\n*\tPrizes will be made available for each working day in March with\neligibility based on the date membership is purchased. A prize\ndraw will take place each day with a single Member selected\nfrom all eligible Members on that day. Winners will be contacted\nwithin 72 hours of being successful. Some prizes will be subject\nto availability.\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "Payment Options",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.png",
    "zoom": null,
    "content": "\n      <img id=\"19-t1\" class=\"19-text halfScale\" src=\"/membership18/static/_content/19-t1.png\" style=\"top: 51px;left: 533px;\">\n      <img id=\"19-text-1\" class=\"19-text halfScale\" src=\"/membership18/static/_content/19-text-1.png\" style=\"top: 215px;left: 530px;\">\n      <img id=\"19-text-2\" class=\"19-text halfScale\" src=\"/membership18/static/_content/19-text-2.png\" style=\"top: 359px;left: 530px;\">\n      <img id=\"19-text-3\" class=\"19-text halfScale\" src=\"/membership18/static/_content/19-text-3.png\" style=\"top: 215px;left: 771px;\">\n      <img id=\"19-text-4\" class=\"19-text halfScale\" src=\"/membership18/static/_content/19-text-4.png\" style=\"top: 308px;left: 771px;\">\n      <img id=\"19-text-5\" class=\"19-text halfScale\" src=\"/membership18/static/_content/19-text-5.png\" style=\"top: 369px;left: 771px;\">\n      <div class=\"addContentLink\" style=\"top: 327px; left: 543px; width: 179px; height: 24px;\">\n        <a href=\"http://www.quins.co.uk/membership\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          page19Enter = new TimelineMax();\n        \n          page19Enter\n          .staggerFromTo(cOf('19-text'), 0.3, {x: 200, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0.5, addContentLinks)\n        }\n\n        function onPageLeave() {\n          page19Enter.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "PAYMENT\nOPTIONS\nDirect Debit\nMake paying for your membership\neasy with Direct Debit. You\ncan spread the cost of your\nmembership with a monthly\npayment plan. Full details can\nbe found in the Direct Debit FAQs\nat quins.co.uk/membership\nCredit/Debit cards\nWe accept all credit and debit\ncards, except for American\nExpress, Diners Club, Solo\nor Electron.\n\nCheque\nCheques can be used for postal\nand in person applications.\nCheques must be made payable\nto Harlequin Football Club Limited.\nCash\nOnly applications in person at\nThe Stoop can be made with cash.\neCash\nIf you have an eCash balance,\nyou can use it to pay toward\nyour membership when you\nrenew online.\n\n19\n\n\f"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img id=\"\" class=\"\" style=\"left:100px; bottom:300px\" src=\"/membership18/static/_content/bearcam.jpg\">\n        <div class=\"addContentLink\" style=\"top: 592px; left: 48px; width: 24px; height: 24px;\">\n          <a href=\"http://www.twitter.com/harlequins\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 592px; left: 78px; width: 24px; height: 24px;\">\n          <a href=\"https://www.facebook.com/harlequins\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 592px; left: 107px; width: 118px; height: 24px;\">\n          <a href=\"https://www.instagram.com/harlequins\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 623px; left: 47px; width: 208px; height: 24px;\">\n          <a href=\"http://www.quins.co.uk/membership\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 682px; left: 47px; width: 239px; height: 24px;\">\n          <a href=\"mailto:customerservice@quins.co.uk\" target=\"_blank\"></a>\n        </div>\n\n        <svg class=\"abs pulse animatedpulse pointer\" onclick=\"Publish.updateVideoURL('https://www.youtube.com/embed/zDJusRB59rA?autoplay=1')\" style=\"width:85px; height:85px;left:288px;top:266px\"version=\"1.1\" id=\"Layer_2\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n              width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n          <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n          <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n        </svg>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks();\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "@harlequins\nquins.co.uk/membership\n020 8410 6010\ncustomerservice@quins.co.uk\n\nHarlequins 2018/19 Membership,\nTicket Office,\nTwickenham Stoop Stadium,\nLanghorn Drive,\nTwickenham,\nTW2 7SX\n\n\f"
  }]],
  "script": "\n    function idOf(id) {\n      return document.getElementById(id)\n    }\n\n    function cOf(klass) {\n      return document.getElementsByClassName(klass)\n    }\n    \n    function removeContentLinks() {\n      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n      contentLinks.map(function callback(e) { \n        return e.className = 'addContentLink'\n      })\n    }\n\n    function addContentLinks() {\n      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n      contentLinks.map(function callback(e) {\n        return e.className = 'contentLink addContentLink'\n      })\n    }\n\n    function showOverlay(idx) {\n      idOf(idx).className = 'contentOverlay visible'\n    }\n\n    function hideOverlay(idx) {\n      idOf(idx).className = 'contentOverlay hidden noclick'\n    }\n  ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: true
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;

    var hammertime = new hammer_default.a(document.getElementById("app"), {});
    hammertime.get('pinch').set({ enable: true });
    hammertime.add(new hammer_default.a.Tap({ event: 'doubletap', taps: 2 }));
    hammertime.add(new hammer_default.a.Tap({ event: 'singletap' }));
    hammertime.get('doubletap').recognizeWith('singletap');
    hammertime.get('singletap').requireFailure('doubletap');

    hammertime.on("singletap", function (e) {
      if ((e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1) && Publish.zoomEnabled) {
        mouse.lastX = e.srcEvent.clientX;
        mouse.lastY = e.srcEvent.clientY;
      }
    });

    hammertime.on("doubletap", function (e) {
      if ((e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1) && Publish.zoomEnabled) {
        Publish.toggleZoom({
          zoomOriginX: e.srcEvent.clientX,
          zoomOriginY: e.srcEvent.clientY
        });
      }
    });

    hammertime.on('pinchin', function (e) {
      Publish.pinchZoom({
        zoomOriginX: e.center.x,
        zoomOriginY: e.center.y,
        zoomLevel: e.scale
      });
    });

    hammertime.on('pinchout', function (e) {
      Publish.pinchZoom({
        zoomOriginX: e.center.x,
        zoomOriginY: e.center.y,
        zoomLevel: e.scale
      });
    });

    hammertime.on('pan', function (e) {
      mouse.x = e.srcEvent.clientX;
      mouse.y = e.srcEvent.clientY;
      mouse.deltaX = mouse.x - mouse.lastX;
      mouse.deltaY = mouse.y - mouse.lastY;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    });

    hammertime.on('panstart', function (e) {
      if (Publish.isZoomed) {
        mouseDown = true;
        mouse.lastX = e.srcEvent.clientX;
        mouse.lastY = e.srcEvent.clientY;
      }
    });

    hammertime.on('panend', function (e) {
      if (mouseDown && Publish.pagesVisible) {
        mouse.lastX = mouse.x;
        mouse.lastX = mouse.y;
        mouseDown = false;
      }
    });

    hammertime.on('swipe', function (e) {
      if (Publish.videoURL == "" && !Publish.isZoomed) {
        if (Publish.isMobile) {
          if (Publish.mobileSwitch) {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextMobilePage();
              } else {
                Publish.goToPreviousMobilePage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousMobilePage();
              } else {
                Publish.goToNextMobilePage();
              }
            }
          } else {
            if (!Publish.isZoomed) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextPage();
                } else {
                  Publish.goToPreviousPage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousPage();
                } else {
                  Publish.goToNextPage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                if (Publish.pagesVisible) Publish.goToNextSection();
              }
            }
          }
        } else {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.goToNextPage();
            } else {
              Publish.goToPreviousPage();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.goToPreviousPage();
            } else {
              Publish.goToNextPage();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_UP) {
            if (Publish.pagesVisible) Publish.goToPreviousSection();
          } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
            if (Publish.pagesVisible) Publish.goToNextSection();
          }
        }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    // if ((e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1) && Publish.zoomEnabled) {
    if (Publish.zoomEnabled) {
      Publish.toggleZoom({
        zoomOriginX: e.clientX,
        zoomOriginY: e.clientY
      });
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == 'INPUT') return;
    if (Publish.isMobile && Publish.mobileSwitch) {
      // if(!Publish.isZoomed){
      if (e.keyCode == '37') {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == '39') {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else {
      if (!Publish.isZoomed) {
        if (e.keyCode == '37') {
          if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
        } // left arrow
        if (e.keyCode == '38') Publish.goToPreviousSection(); // up arrow
        if (e.keyCode == '39') {
          if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
        } // right arrow
        if (e.keyCode == '40') Publish.goToNextSection(); // down arrow
      }
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js

/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute('data-useragent', navigator.userAgent);
    documentElement.setAttribute('data-platform', navigator.platform);
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler() {
    Publish.changeWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-111093701-2',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPage', 'pagesVisible', 'isZoomed', 'showContents', 'zoomLevel', 'rightToLeft', 'zoomEnabled', 'isMobile', 'mobileSwitch', 'currentMobilePageIndex', 'videoURL'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: 'TOGGLE_ZOOM'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'goToPreviousMobilePage', 'goToNextMobilePage', 'updateZoom', 'startZoom', 'changeWindowSize', 'checkMobileLanding', 'updateVideoURL', 'pinchZoom', 'panZoom'])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    this.changeWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OXBz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QE36":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gmqq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h0Q/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jsA2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qdF7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.61a61a9dc3c571ba4815.js